import React, {useState}						from 'react';
import SvgColor									from 'react-svg-color';

import Checkbox									from '../Checkbox';

import {BadgeProps}								from './interface';

import ft_cssVar								from '../../functions/getCssVar';

import img_close								from '../../images/icon/close.svg';

import './Badge.css';


const defaultProps: BadgeProps = {
	color:    'primary',
	size:     'md'
};

function Badge(props: BadgeProps) {
	props = {...defaultProps, ...props};

	const [isClose, set_isClose] = useState(false);

	let closeColor = ft_cssVar(props.color === 'tertiary' ? 'primary-500' : `${props.color}-500`);

	if (props.color === 'tags')
		closeColor = ft_cssVar('gray-300');

	if (props.style?.color)
		closeColor = props.style.color;

	if (isClose)
		return <></>;

	let className = `badge ${props.size} ${props.onClick && 'onClick'} `;

	if (props.color === 'tertiary' || props.color === 'tags')
		className += props.color;
	else
		className += `${!props.style?.backgroundColor && `${props.color}-${props.color === 'gray' ? '10' : '5'}0-background`} ${props.color}-700`;

	return (
		<div
			key={props.key}
			style={{
				...props.style,
				...props.fullWidth ? {flex: 1, width: 'auto'} : {}
			}}
			className={className}
			onClick={props.onClick}
		>
			{props.checkbox &&
				<Checkbox
					size={14}
					active={props.checked}
				/>
			}

			{!props.childrenAfter && props.children}

			{(props.round) &&
				<div className={`badgeRound ${props.size} ${props.color}-500-background`} />
			}
			{props.img &&
				<div style={{backgroundImage: `url(${props.img}`}} className={`badgeImg ${props.notRoundImg && 'notRound'}`} />
			}
			<span>{props.text}</span>
			{props.childrenAfter && props.children}

			{(props.close || props.onClose) &&
				<div
					className={'badgeClose'}
					onClick={() => {
						if (props.onClose)
							props.onClose();
						if (props.close)
							set_isClose(true);
					}}
				>
					<SvgColor
						svg={img_close}
						colors={[closeColor]}
					/>
				</div>
			}
		</div>
	);
}

export default Badge;